import { Route } from "@angular/router";
import { AuthGuard } from "@app/core/authentication";
import { ClientLayoutComponent } from "@app/shared/components";
import { routeAccess } from "./config/config";

export const appRoutes: Route[] = [
  {
    path: "",
    component: ClientLayoutComponent,
    // canActivate: [AuthGuard],
    data: { roles: routeAccess.allRoles },
    children: [
      /**
       * * Dashboard
       */
      {
        path: "invoice",
        loadChildren: () => import("@app/invoice").then((m) => m.InvoiceModule),
      },
    ],
  },
  { path: "**", redirectTo: "invoice" }, // redirect to home
];
